import { ViewChild, Component, Input, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'plan-progress-bar',
  templateUrl: './plan-progress-bar.component.html',
  styleUrls: ['./plan-progress-bar.component.scss']
})
export class PlanProgressBarComponent implements OnInit {

  @Input() planned: number;
  @Input() delivered: number;
  @ViewChild('progressbar', { static: true }) progressBar: ElementRef;
  progress: string;

  constructor(
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.progress = Math.round((((this.delivered * 100) / this.planned) || 0)) + '%';
    this.renderer.setStyle(this.progressBar.nativeElement, 'width', this.progress);
  }

}
